import React from 'react';
import { Scrollbars as CustomScrollbars } from 'react-custom-scrollbars';

const Scrollbars = props => (
  <CustomScrollbars
    universal
    renderTrackHorizontal={trackProps => (
      <div
        {...trackProps}
        className="track-horizontal"
        style={{ display: props.disablex ? 'none' : 'initial' }}
      />
    )}
    {...props}
  />
);

export default Scrollbars;
